import React from 'react';
import classnames from 'classnames';
import { Icon } from '@doxyme/ui';
import { localeService } from '../../../core/helpers/locale-service';
import { isDoctor, isPatient } from '../../helpers';
import { CallFrameVariant } from '../../constants';
import './SelfPublisherError.scss';
const getMessage = (variant) => {
    let messageId;
    if (variant === CallFrameVariant.Mini) {
        messageId = 'video-chat.publisher-error.your-video-unavailable';
    }
    if (variant === CallFrameVariant.Full && isDoctor()) {
        messageId = 'video-chat.publisher-error.provider.own-issue';
    }
    if (variant === CallFrameVariant.Full && isPatient()) {
        messageId = 'video-chat.publisher-error.participant.own-issue';
    }
    return localeService.formatMessageById(messageId);
};
export const SelfPublisherError = ({ variant }) => {
    const message = getMessage(variant);
    return (<div className={classnames({
            'react-sp-error': true,
            [`react-sp-error--${variant}`]: true
        })}>
      <div className="react-sp-error__content">
        <Icon name="call-video-off" className="react-sp-error__icon" size="small"/>
        <div className="react-sp-error__message">{message}</div>
      </div>
    </div>);
};
